// extracted by mini-css-extract-plugin
export default {"formItem":"FileInput_formItem__O2OJw","File":"FileInput_File__dAjhr","dropzone":"FileInput_dropzone__lTDyU"};